import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { AirportsService } from 'src/app/_services/api/airports/airports.service';

@Injectable({
  providedIn: 'root'
})
export class AirportsResolver implements Resolve<boolean> {
  constructor(
    private airportsService: AirportsService,
    private logger: LoggerService,
    private router: Router,
  ) {

  }
  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    if (!this.airportsService.airports.length) {
      try {
        await this.airportsService.getAirports();
      }
      catch (e) {
        this.logger.error(e)        
        this.router.navigate(['/error'], { replaceUrl: true })
      }
    }
    return true;
  }
}
